export const galleryLink = (object, id, side = 'front', size = 'normal') => {
    switch (object) {
        case 'sealed': return `https://guildmage.pl/images/${id}.png`;
        default: return `https://cards.scryfall.io/${size}/${side}/${id[0]}/${id[1]}/${id}.jpg`;
    }
}
